<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @audit="auditFun(arguments)"
        />
      </div>

      <!-- 审核确认 -->
      <audit-dialog
        :data-id="id"
        :dialog-title="dialogAuditTitle"
        :dialog-visible.sync="dialogAuditVisible"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 审核确认
import auditDialog from './auditDialog'
import { loadMaterialsDemandListDataApi } from '@/api/materialsDemandDetail'

export default {
  name: 'MaterialsDemandTodoAuditList',
  components: { CustomTable, auditDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    sourceType: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_demand_task_audit_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'audit',
            label: '审核',
            method: 'audit'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            materialsName: '',
            status: 3
          }
        }
      },
      isPaging: true,
      typeOptions: [{ value: 1, label: '方案需求' }, { value: 2, label: '方案外需求' }],
      executeMethodOptions: [{ value: 1, label: '新制作/购买' }, { value: 3, label: '外部租赁' }],
      id: null,
      dialogAuditTitle: '审核确认物料需求申请',
      dialogAuditVisible: false,
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          // { prop: 'typeValue', label: '需求类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 105 },
          { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
          { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 90 },
          { prop: 'schemeContent', label: '需求来源', filterColumn: 'scheme_content', width: 200 },
          { prop: 'demandSide', label: '需求方', filterColumn: 'demand_side', width: 120 },
          { prop: 'materialsName', label: '需求物料名称', filterColumn: 'materials_name', width: 150 },
          { prop: 'applyMakeNumber', label: '需求物料数量', filterColumn: 'apply_make_number', width: 125, isBetween: true },
          { prop: 'executeMethodValue', label: '需求执行方式', filterColumn: 'execute_method', filterValue: 'executeMethod', filterArray: this.executeMethodOptions, width: 130 },
          { prop: 'receiveDepotName', label: '收货库房', filterColumn: 'receive_depot_name', width: 120 },
          { prop: 'submitterName', filterColumn: 'submitter_name', label: '提交人', width: 100 },
          { prop: 'submitTimeValue', filterColumn: 'submit_time', label: '提交时间', width: 150, isBetween: true },
          { prop: 'remark', label: '备注', width: 150 },
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.sort.order = ''
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      loadMaterialsDemandListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 审核
    auditFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要审核的物料需求申请', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogAuditVisible = !this.dialogAuditVisible
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
